import { BROADCAST_MUTE_AUDIO } from '../Types';
import { commonWebAnalytics } from '@studio/metrics';

function muteAudio(canUnmute = true, isRemoteToggle = false) {
  return async (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();

    // SLI payload
    const sliPayload = {
      microphoneState: 'OFF',
      isRemoteToggle
    };

    // Start SLI measurement
    commonWebAnalytics.startStudioMicrophoneToggled(sliPayload);

    try {
      await meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(canUnmute);
      await meetingSession.audioVideo.realtimeMuteLocalAudio();

      const action = {
        type: BROADCAST_MUTE_AUDIO,
        payload: meetingSession.audioVideo.realtimeIsLocalAudioMuted()
      };

      dispatch(action);

      // End SLI measurement on success
      commonWebAnalytics.endStudioMicrophoneToggled(sliPayload);
    } catch (error) {
      console.error('[muteAudio] Failed to mute microphone:', error);

      // End SLI measurement on error
      commonWebAnalytics.endStudioMicrophoneToggled({
        ...sliPayload,
        error: error?.message
      });

      throw error;
    }
  };
}

export default muteAudio;
